<!-- 现场服务运维单表单 -->
<template>
  <layui-collapse ref="collapse" class="requestForm">
    <div class="layui-colla-item">
      <h2 class="layui-colla-title">
        {{ editRow.WORK_ORDER_CATEGORY === '1' ? '现场服务运维单基本信息' : '现场服务工程单基本信息' }}
      </h2>
      <div class="layui-colla-content layui-show">
        <div class="layui-form-item-two layui-form-column">
          <div class="layui-form-colun-inner">
            <div class="layui-form-item-left">
              <div class="layui-form-item">
                <label class="layui-form-label">服务请求单编号：</label>
                <label class="layui-form-label right">{{editRow.WORK_ORDER_NUM}}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">服务商：</label>
                <label class="layui-form-label right">{{editRow.SERVICE_NAME}}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">工程师：</label>
                <label class="layui-form-label right">{{editRow.ENGINEER_NAME}}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">是否更换备件：</label>
                <label class="layui-form-label right" style="width:4%">
                  <layui-switch :enabled="false" v-model="editRow.NEED_REPAIR_PART"> </layui-switch>
                </label>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_REPAIR_PART == 1">
                <label class="layui-form-label">客户备件：</label>
                <div class="layui-input-inline" id="repairCustomerPart" style="width: 55%;">
                  <layui-multiselect
                    ref="customerRepairSelect"
                    :single="false"
                    :enabled="false"
                    :renderText="renderCustomerRepairPartText"
                    table-name="YW_REPAIR_PART"
                    text-field="REPAIR_PART_NAME"
                    value-field="REPAIR_PART_ID"
                    :show-null-option="true"
                    :enable-search="true"
                    v-model="editRow.CLIENT_REPAIR_PART"
                  ></layui-multiselect>
                </div>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_REPAIR_PART == 1">
                <label class="layui-form-label">自有备件：</label>
                <div class="layui-input-inline" id="repairPart" style="width: 55%;">
                  <layui-multiselect
                    :single="false"
                    :enabled="false"
                    :renderText="renderRepairPartText"
                    table-name="YW_REPAIR_PART"
                    text-field="REPAIR_PART_NAME"
                    value-field="REPAIR_PART_ID"
                    :show-null-option="true"
                    :queryCondition="{}"
                    :enable-search="true"
                    v-model="editRow.YW_REPAIR_PART_ID"
                  ></layui-multiselect>
                </div>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_REPAIR_PART == 1">
                <label class="layui-form-label">备件收入金额：</label>
                <label class="layui-form-label right textarea">{{editRow.INCOME_REPAIR_PART_AMOUNT}}</label>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_REPAIR_PART == 1">
                <label class="layui-form-label">备件支出金额：</label>
                <label class="layui-form-label right textarea">{{editRow.EXPENSES_REPAIR_PART_AMOUNT}}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">描述：</label>
                <label class="layui-form-label right textarea">{{editRow.SERVICE_DESCRIPTION}}</label>
              </div>
            </div>
            <div class="layui-form-item-right">
              <div class="layui-form-item">
                <label class="layui-form-label">标准处理时间：</label>
                <label class="layui-form-label right">{{ editRow.START_TIME }} - {{ editRow.END_TIME }}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">标准处理时长(h)：</label>
                <label class="layui-form-label right">{{ editRow.STANDARD_PROCESSING_TIME }}</label>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label">预约时间：</label>
                <label class="layui-form-label right">{{ editRow.APPOINTMENT_TIME }}</label>
              </div>

              <div class="layui-form-item">
                <label class="layui-form-label">是否临采：</label>
                <div class="layui-input-inline" style="width:4%">
                  <layui-switch :enabled="false" v-model="editRow.NEED_PURCHASING"> </layui-switch>
                </div>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_PURCHASING == 1">
                <label class="layui-form-label">产品名称：</label>
                <label class="layui-form-label right textarea">{{ editRow.PRODUCT_NAME }}</label>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_PURCHASING == 1">
                <label class="layui-form-label">产品型号：</label>
                <label class="layui-form-label right textarea">{{ editRow.PRODUCT_MODEL }}</label>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_PURCHASING == 1">
                <label class="layui-form-label">产品序列号：</label>
                <label class="layui-form-label right textarea">{{ editRow.PRODUCT_SERIAL }}</label>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_PURCHASING == 1">
                <label class="layui-form-label">产品支出金额：</label>
                <label class="layui-form-label right textarea">{{ editRow.PRODUCT_EXPENSES_AMOUNT }}</label>
              </div>
              <div class="layui-form-item" v-if="editRow.NEED_PURCHASING == 1">
                <label class="layui-form-label">产品收入金额：</label>
                <label class="layui-form-label right textarea">{{ editRow.PRODUCT_INCOME_AMOUNT }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="layui-form-item-one">
          <div class="layui-form-item">
            <label class="layui-form-label">附件：</label>
            <div class="layui-input-inline" style="width:80%">
              <layui-listfileupload v-model="editRow.FJ_ID" :enabled="false"> </layui-listfileupload>
            </div>
          </div>
        </div>
        <div v-if="editRow.WORK_ORDER_CATEGORY == '2'">
                <div class="layui-form-item bpm-thumb-box">
                  <label for="" class="layui-form-label">工作流程：</label>
                  <div class="layui-input-inline">
                    <bpm
                      ref="refBpm"
                      type="select"
                      height="300px"
                      :selected="bpmSelNodeId"
                      :bpmData="bpmInfo.data"
                      :isDisabledFn="bpmDisabledFn"
                    />
                  </div>
                </div>
                <div class="layui-form-item show-content">
                  <label for="" class="layui-form-label">总备注：</label>
                  <div class="layui-input-inline" style="width: calc(100% - 180px)">{{ bpmInfo.totalBZ || '-' }}</div>
                </div>
                <div class="layui-form-item show-content">
                  <label for="" class="layui-form-label">流程附件：</label>
                  <div class="layui-input-inline bpmFile">
                    <div v-for="item in bpmInfo.classFiles" :key="item.node_name">
                      <span>{{ item.node_name }}</span>
                      <layui-fileupload ref="bpmFile" v-model="item.files" :enabled="false" />
                    </div>
                  </div>
                </div>
              </div>
      </div>
    </div>
    <div class="layui-colla-item">
      <h2 class="layui-colla-title">服务商信息</h2>
      <div class="layui-colla-content layui-show">
        <div class="layui-form-item-two">
          <div class="layui-form-item-left">
            <div class="layui-form-item">
              <label class="layui-form-label">服务商名称：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_NAME}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">服务商性质：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_NATURE_DESC}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">服务商类型：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_TYPE_DESC}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">联系电话：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_TELE}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">所属地：</label>
              <label class="layui-form-label right">{{
                (editRow.SERVICE_P ? editRow.SERVICE_P_DESC : '') +
                  '' +
                  (editRow.SERVICE_C ? editRow.SERVICE_C_DESC : '') +
                  '' +
                  (editRow.SERVICE_D ? editRow.SERVICE_D_DESC : '')
              }}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">地址：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_ADDRESS}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">备注：</label>
              <label class="layui-form-label right textarea">{{editRow.SERVICE_BZ}}</label>
            </div>
          </div>
          <div class="layui-form-item-right">
            <div class="layui-form-item">
              <label class="layui-form-label">身份证号：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_ID_CARD}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">是否开票：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_IS_BILL_DESC}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">开票名称：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_BILL_NAME}}  </label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">纳税人识别号：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_TAXPAPYER_NUM}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">开户行：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_BANK}}</label>
            </div>
            <div class="layui-form-item">
              <label class="layui-form-label">银行卡号：</label>
              <label class="layui-form-label right">{{editRow.SERVICE_BANK_NUM}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layui-collapse>
</template>
<script>
import bpm from '../bpm/bpm.vue'
export default {
  components: {
    bpm
  },
  props: {
    editRow: {
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      bpmInfo: {
        totalBZ: '',
        totalFiles: '',
        classFiles: [],
        data: []
      },
      bpmSelNodeId: []
    }
  },
  mounted() {
    this.$nextTick(()=>{
      //工程单流程
      if(this.editRow.WORK_ORDER_CATEGORY == '2'){
        this.api
          .queryList('YW_TEMPLATE', {p2: { 'TEMPLATE_ID:0': this.editRow.TEMPLATE_ID }}, 'detail_bpm-tpl')
          .then(response => {
            var data = response.result[0] || { TEMPLATE_NODE: undefined }
            let bpmInfo = {...data, TEMPLATE_NODE: undefined}
            if(data.TEMPLATE_NODE) {
              bpmInfo.data = JSON.parse(data.TEMPLATE_NODE);
            } else {
              bpmInfo.data = [];
            }
            this.bpmInfo = bpmInfo
            let t = this.$refs['refBpm'].getTplNodeInfo(bpmInfo)
            bpmInfo.totalBZ = t.totalBZ
            if (t.totalFiles) {
              bpmInfo.totalFiles = t.totalFiles
              bpmInfo.classFiles = t.classFiles
            } else {
              // this.$refs['bpmFile'].setValue('')
            }
          });
        this.api
          .queryList(
            'YW_SERVICE_ORDER_V1',
            {
              p2: { 'F_WORK_ORDER_ID:0': this.editRow.WORK_ORDER_ID },
              p9: 'SERVICE_ORDER_ID,WORK_ORDER_ID,TEMPLATE_NODEID,TEMPLATE_ID'
            },
            'getAllOrderBpmTplNode'
          ).then(response => {
            let rd = response.result || []
            let allNodes = []
            rd.map(v => {
              if (v.TEMPLATE_NODEID)
                v.TEMPLATE_NODEID.split(',').map(n => {
                  let newNode = { id: n, ...v }

                  allNodes.push(newNode)
                })
            })
            this.bpmSelNodeId = allNodes
          })
      }
    })
  },
  methods:{
    bpmDisabledFn: function(param) {
      return true
    },
    renderRepairPartText(row) {
      if (row) {
        var width = $('#repairPart').width() - 20 - 12 - 30
        var titleArr = []
        var arr = []
        arr.push('<span style="font-weight:bold;color:black">备件名称：</span>' + row.REPAIR_PART_NAME)
        titleArr.push('备件名称：' + row.REPAIR_PART_NAME)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">序列号：' + '</span>' + row.REPAIR_PART_SERIAL
        )
        titleArr.push('序列号：' + row.REPAIR_PART_SERIAL)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">型号：' + '</span>' + row.REPAIR_PART_MODEL
        )
        titleArr.push('型号：' + row.REPAIR_PART_MODEL)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">仓库：' +
            '</span>' +
            row.REPAIR_PART_STORE_DESC
        )
        titleArr.push('仓库：' + row.REPAIR_PART_STORE_DESC)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">金额：' + '</span>' + row.REPAIR_PART_MONEY
        )
        titleArr.push('金额：' + row.REPAIR_PART_MONEY)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">类别：' +
            '</span>' +
            row.REPAIR_PART_CATEGORY_DESC
        )
        titleArr.push('类别：' + row.REPAIR_PART_CATEGORY_DESC)
        return (
          '<div style="white-space: nowrap;max-width:' +
          width +
          'px;overflow: hidden;" title="' +
          titleArr.join(' ') +
          '">' +
          arr.join('') +
          '</div>'
        )
      }
    },
    renderCustomerRepairPartText(row) {
      if (row) {
        var width = $('#repairCustomerPart').width() - 20 - 12 - 30
        var titleArr = []
        var arr = []
        arr.push('<span style="font-weight:bold;color:black">备件名称：</span>' + row.REPAIR_PART_NAME)
        titleArr.push('备件名称：' + row.REPAIR_PART_NAME)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">型号：' + '</span>' + row.REPAIR_PART_MODEL
        )
        titleArr.push('型号：' + row.REPAIR_PART_MODEL)
        arr.push(
          '<span style="margin-left:5px;font-weight:bold;color:black">序列号：' + '</span>' + row.REPAIR_PART_SERIAL
        )
        titleArr.push('序列号：' + row.REPAIR_PART_SERIAL)
        return (
          '<div style="white-space: nowrap;max-width:' +
          width +
          'px;overflow: hidden;" title="' +
          titleArr.join(' ') +
          '">' +
          arr.join('') +
          '</div>'
        )
      }
    }
  }
}
</script>
<style lang="postcss">
.core .bpm-thumb-box {
  display: flex;

  & > .layui-input-inline {
    margin: 0;
    flex: 1;
    width: 0;
    border: 1px solid #ddd;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/detailForm/serviceOrderForm.vue